/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, {useContext} from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../../../components/Context/GloablContext';

const TableBody = ({ tableData}) => {
    const { isInactiveBranch } = useContext(GlobalContext)
    return (
        <>
            <AnimatedList
                rowStatus={true}
                child={
                    <>
                        <td class="text-start" data-testid="student-name">{tableData?.student_name} [{tableData?.student_id}]</td>
                        <td class="text-start">{tableData?.class_name}, {tableData?.section_name}</td>
                        <td class="text-end">
                            {tableData?.pending_amount === undefined ? "0.00" : tableData?.pending_amount.toString() === "" || tableData?.pending_amount.toString() === undefined ? "-" : tableData?.pending_amount.toString().includes(".") ? tableData?.pending_amount.toString().split(".")[1]?.length === 2 ? tableData?.pending_amount.toString() : tableData?.pending_amount.toString()+"0"  : parseFloat(tableData?.pending_amount).toFixed(2) || "-"}</td>
                        <td class="prevent-click">
                            <div class="w-full flex justify-center">
                                <Link 
                                    to={isInactiveBranch ? "#" : `/student-master/collect-fee/collect-fee-invoice/${tableData?.student_uuid}`} 
                                    id="collect_fee" type="button" className={`list-actn-btn ${isInactiveBranch ? "disabled" : ""}`}>
                                    Collect Fee
                                </Link>
                            </div>
                        </td>
                    </>
                }/>
          
            
        </>
        
    );
}

export default TableBody;
